import { render, staticRenderFns } from "./CatalogItem.vue?vue&type=template&id=3175b82c&scoped=true"
import script from "./CatalogItem.vue?vue&type=script&lang=js"
export * from "./CatalogItem.vue?vue&type=script&lang=js"
import style0 from "./CatalogItem.vue?vue&type=style&index=0&id=3175b82c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3175b82c",
  null
  
)

export default component.exports